import React from 'react';
import { Textarea } from 'components';
import { ReferralService } from 'services';
import { Globals, Constants } from 'utils';
import moment from 'moment';

interface Props {
  item?: any;
  onClose?: () => void;
}

interface State {
  admin_notes: string;
}

class ModalProcess extends React.Component<Props, State> {
  state: State = {
    admin_notes: '',
  };

  process = async (status: number) => {
    const { item } = this.props;
    if (!item) return;

    const actionText =
      status === Constants.REFERRAL_WITHDRAWAL_STATUS.PAID ? 'aprobar' : 'rechazar';

    Globals.confirm(`¿Desea ${actionText} esta solicitud de retiro?`, async () => {
      await ReferralService.admin.process({
        id: item.id,
        status,
        admin_notes: this.state.admin_notes || undefined,
      });
      Globals.showSuccess(
        status === Constants.REFERRAL_WITHDRAWAL_STATUS.PAID
          ? 'Solicitud aprobada correctamente'
          : 'Solicitud rechazada correctamente',
      );
      if (this.props.onClose) this.props.onClose();
    });
  };

  render() {
    const { item } = this.props;
    if (!item) return null;

    const isPending = item.status === Constants.REFERRAL_WITHDRAWAL_STATUS.PENDING;
    const bankData = item.user?.bank_data;

    return (
      <div id='modal-view-referral-withdrawal'>
        <div className='container-modal'>
          <p className='number'>
            #{item.id} / {moment(item.created_at).format('DD-MM-YYYY')}
          </p>

          <p className='subtitle'>Usuario</p>
          <p>{item.user?.full_name || item.user?.name}</p>

          <p className='subtitle'>Monto solicitado (tokens)</p>
          <p>{parseFloat(item.amount).toFixed(2)}</p>

          <div className='bank-data'>
            <p className='subtitle'>Datos de pago móvil</p>
            <p>{bankData?.payment_mobile_bank?.name || '-'}</p>
            <p>
              <span>Teléfono </span>
              {bankData?.payment_mobile_phone || '-'}
            </p>
            <p>
              <span>CI </span>
              {bankData?.payment_mobile_document || '-'}
            </p>
          </div>

          {!isPending && (
            <div className='processed'>
              <p className='subtitle'>Procesado el</p>
              <p>
                {item.processed_at ? moment(item.processed_at).format('DD-MM-YYYY HH:mm') : '-'}
              </p>
            </div>
          )}

          {isPending ? (
            <div className='container-actions'>
              <Textarea
                label='Notas del administrador (opcional)'
                name='admin_notes'
                rows={3}
                value={this.state.admin_notes}
                onChange={(e: any) => this.setState({ admin_notes: e.target.value })}
              />
              <div className='container-btn-referral'>
                <button
                  className='btn btn-approve'
                  onClick={() => this.process(Constants.REFERRAL_WITHDRAWAL_STATUS.PAID)}
                >
                  Aprobar
                </button>
                <button
                  className='btn btn-reject'
                  onClick={() => this.process(Constants.REFERRAL_WITHDRAWAL_STATUS.REJECTED)}
                >
                  Rechazar
                </button>
              </div>
            </div>
          ) : (
            <div className='processed'>
              <p className='subtitle'>Notas</p>
              <p>{item.admin_notes || '-'}</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ModalProcess;
